'use client';
import { SxProps, Stack, useTheme, Link } from '@mui/material';
import Img from 'next/image';
import { TBImgType } from '../../utils/mappers/image';

export type LogoProps = {
  light: TBImgType | undefined;
  dark?: TBImgType;
  direction?: 'row' | 'column';
  height?: number;
  sx?: SxProps;
  aspectRatio?: number;
  mode?: 'light' | 'dark';
  withLink?: boolean;
  onClick?: () => void;
};

const Logo = ({
  direction = 'row',
  height = 56,
  mode,
  sx,
  withLink,
  aspectRatio,
  onClick,
  light,
  dark,
}: LogoProps) => {
  const theme = useTheme();
  const width = (aspectRatio || 1) * height;
  const isLight = (mode || theme.palette.mode) === 'light' || !dark;
  const img = isLight ? light : dark;
  if (!img) return null;
  return (
    <Stack
      direction={direction}
      spacing={1}
      sx={{ justifyContent: 'center', alignItems: 'center', ...sx }}
      onClick={onClick}
      component={withLink ? Link : 'div'}
      href={'/'}
    >
      <Img
        src={img.url}
        alt={img.altText}
        width={width}
        height={height}
        preload
        quality={100}
      />
    </Stack>
  );
};

export default Logo;
